import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import axios from "axios";
import { flashDispatch, flashMessage } from "@/shared/helpers";
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage";
import { sendFlashMessage } from "@/redux/actions/flashActions";

const RequestReclaimModal = ({
  isOpen, setOpen, toggle, participants, program, organization, setRefreshUsers
}) => {
  const dispatch = flashDispatch();
  const [loading, setLoading] = useState(false);
  const [locked, setLocked] = useState(false);

  const participant = Array.isArray(participants) ? participants[0] : participants;

  // Reset state on open
  useEffect(() => {
    if (isOpen) {
      setLocked(false);
      setLoading(false);
    }
  }, [isOpen]);

  const handleConfirmReclaim = () => {
    setLoading(true);
    axios
      .put(
        `/organization/${program.organization_id}/program/${program.id}/user/${participant.id}/lockaccount`,
        { reason: "Request Reclaim" }
      )
      .then((res) => {
        if (res.status === 200) {
          dispatch(flashMessage("Participant account locked successfully!"));
          setRefreshUsers(true);
          setLocked(true);
        }
      })
      .catch((error) => {
        if (error?.response?.data) {
          dispatch(
            sendFlashMessage(
              <ApiErrorMessage errors={error.response.data} />,
              "alert-danger"
            )
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const SUPPORT_URL = "https://incentco.zendesk.com/hc/en-us/requests/new?ticket_form_id=23348820658452";

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: "600px" }}>
      <ModalHeader toggle={toggle} className={!locked ? "text-danger" : ""}>
        {locked ? "Reclaim Request Instructions" : "Request Reclaim"}
      </ModalHeader>
      <ModalBody>
        {!locked ? (
          <>
            <p>You are about to request a reclaim for <strong>{participant?.name || participant?.first_name + ' ' + participant?.last_name}</strong>.</p>
            <p className="text-danger">This action will <strong>lock</strong> the participant's account.</p>
            <p>Reclaims are only eligible for recent awards made in error. All requests are subject to review and approval.</p>
          </>
        ) : (
          <>
            <div className="alert alert-success">
              Account has been locked. Please follow the instructions below to complete your reclaim request.
            </div>
            <h5>Instructions:</h5>
            <p>Please open a support ticket and include the following details:</p>
            <ul>
              <li><strong>Participant Email Address:</strong> {participant?.email}</li>
              <li><strong>Date of Award:</strong> [Please provide the date of the award made in error]</li>
              <li><strong>Amount of Award:</strong> [Please provide the amount of the award made in error]</li>
            </ul>
            <p className="mt-4">
              <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Submit a request – Rewards Program Support
              </a>
            </p>
          </>
        )}
      </ModalBody>
      <ModalFooter className="align-content-center align-items-baseline d-flex justify-content-end">
        {!locked ? (
          <>
            <button type="button" className="btn-cancel mb-0" onClick={toggle} disabled={loading}>
              Cancel
            </button>
            <Button className="mb-0" color="danger" onClick={handleConfirmReclaim} disabled={loading}>
              {loading ? "Locking..." : "Lock Account & Continue"}
            </Button>
          </>
        ) : (
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default RequestReclaimModal;
